export default "__VITE_ASSET__DAJyeg$g__"